import { Box } from '@mui/material';
import { useField } from 'formik';
import { WhatNeedsUpdating } from '@uplift/ui-v2';
import { Session } from '@uplift/api';
import { AmendAddendumCptSection } from './amend-addendum-cpt-section.component';
import { AmendAddendumDiagnosisSection } from './amend-addendum-diagnosis-section.component';

export type AddendumCorrectionSectionsProps = {
  providerId: string;
  session: Session;
};

export const AddendumCorrectionSections: React.VFC<AddendumCorrectionSectionsProps> = ({ providerId, session }) => {
  const [ { value: whatNeedsUpdating } ] = useField<WhatNeedsUpdating[]>('whatNeedsUpdating');

  return (
    <Box display="flex" flexDirection="column" gap={3}>
      {whatNeedsUpdating.includes('cpt') && <AmendAddendumCptSection providerId={providerId} session={session} />}
      {whatNeedsUpdating.includes('dx') && <AmendAddendumDiagnosisSection session={session} />}
    </Box>
  );
};
